// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpressCheckoutButton_container__qmvbe","button":"ExpressCheckoutButton_button__LzYUA"};